import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import HomeList from './components/HomeList';
import HomeMobile from './components/HomeMobile';

const { Cell } = ResponsiveGrid;

const Home = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="首頁列表"
        breadcrumbs={[
          {
            name: '首頁',
          },
          {
            name: '首頁列表',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <HomeList />
    </Cell>
  </ResponsiveGrid>
 


  
);

export default Home;
